import React from "react";
import Beryllus from "./images/beryllus-capital.jpeg";
import RBC from "./images/Royal-Bank-of-Canada.png";
import BON from "./images/bon.jpeg";

const Partners = () => {
  return (
    <section id="clients" className="clients section-bg">
      <div className=" mx-auto container">
        <h2 className="headings text-center" style={{ fontSize: "2rem" }}>
          Our Strategic Partners
        </h2>
        <div className="row">
          <div
            className=" mx-auto col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img src={Beryllus} className="img-fluid" alt="" />
          </div>
          <div
            className=" mx-auto col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Boston_Consulting_Group_2020_logo.svg/3840px-Boston_Consulting_Group_2020_logo.svg.png"
              className="img-fluid"
              alt=""
            />
          </div>
          <div
            className=" mx-auto col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img
              src="https://1000logos.net/wp-content/uploads/2021/05/UBS-logo.png"
              className="img-fluid"
              alt=""
            />
          </div>

          <div
            className=" mx-auto  col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img
              src="https://logodownload.org/wp-content/uploads/2019/10/pwc-logo.png"
              className="img-fluid"
              alt=""
            />
          </div>
        </div>
        <div className="row">
          <div
            className=" mx-auto  col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/MUFG_logo.svg/3840px-MUFG_logo.svg.png"
              className="img-fluid"
              alt=""
            />
          </div>
          <div
            className=" mx-auto  col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img src={BON} className="img-fluid" alt="" />
          </div>
          <div
            className=" mx-auto  col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img src={RBC} className="img-fluid" alt="" />
          </div>
          <div
            className=" mx-auto col-lg-2 col-md-4 col-6 d-flex align-items-center justify-content-center"
            data-aos="zoom-in"
          >
            <img
              src="https://www.pngkey.com/png/full/243-2431396_marriott-logo-horizontal-marriott-international-logo-transparent.png"
              className="img-fluid"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
